import en from './locales/en.json';
import de from './locales/de.json';

export const analyticsLocales = {
  en: { analytics: en },
  de: { analytics: de },
};

export { default as AnalyticsPage } from './AnalyticsPage.vue';
export { default as TransactionsPage } from './TransactionsPage.vue';
export * from './analytics.routes';
